package navigation.home.invoice

import navigation.home.invoice.allinvoice.AllInvoiceScreenModel
import navigation.home.invoice.addeditinvoice.AddEditInvoiceScreenModel
import org.koin.core.module.dsl.factoryOf
import org.koin.dsl.module

val invoiceUiModule
    get() =
        module {
            factoryOf(::AllInvoiceScreenModel)
            factoryOf(::AddEditInvoiceScreenModel)
        }
